const versionSubjectCollectionOptions = [
  {
    value: 'guildMembers',
    label: 'Guild Members',
    icon: 'hive',
    iconLibrary: 'material',
    parentCollection: 'guilds',
    parentAvatarShape: 'circle',
  },
  {
    value: 'projectMembers',
    label: 'Project Members',
    icon: 'business_center',
    iconLibrary: 'material',
    parentCollection: 'projects',
    parentAvatarShape: 'rounded',
  },
  {
    value: 'guildProjects',
    label: 'Guild Projects',
    icon: 'diversity_3',
    iconLibrary: 'material',
    parentCollection: 'guilds',
    parentAvatarShape: 'circle',
  },
];
const versionSubjectCollectionMap = 
  Object.fromEntries(versionSubjectCollectionOptions.map((o) => [o.value, o]));

const versionResponseStatusOptions = [
  { 
    value: 'approved',
    label: 'Approved',
    icon: 'check_circle',
    iconLibrary: 'material',
  },
  { 
    value: 'declined',
    label: 'Declined',
    icon: 'cancel',
    iconLibrary: 'material',
  },
];
const versionResponseStatusMap = Object.fromEntries(
  versionResponseStatusOptions.map((o) => [o.value, o])
);

const versionStatusOptions = [
  { 
    value: 'draft',
    label: 'Draft',
    icon: 'draft',
    iconLibrary: 'material',
    description: "Version is still being drafted and not yet submitted for approval",
  },
  { 
    value: 'locked',
    label: 'Locked',
    icon: 'lock',
    iconLibrary: 'material',
    description: "Version has been finalized, is locked and can't be edited",
  },
  { 
    value: 'adopted',
    label: 'Adopted',
    icon: 'task_alt',
    iconLibrary: 'material',
    description: "Version has been adopted and is now the current version",
  },
  { 
    value: 'replaced',
    label: 'Replaced',
    icon: 'fast_forward',
    iconLibrary: 'material',
    description: "Version was previously adopted, but has since been replaced by a newer version",
  },
  { 
    value: 'abandoned',
    label: 'Abandoned',
    icon: 'cancel_presentation',
    iconLibrary: 'material',
    description: "Version was never adopted and is now archived",
  },
];
const versionStatusMap = Object.fromEntries(
  versionStatusOptions.map((o) => [o.value, o])
);

const versionApprovalStatusOptions = [
  { 
    value: 'proposed',
    label: 'Proposed',
    icon: 'help_center',
    iconLibrary: 'material',
    description: "Proposal has been initiated and is pending approval",
  },
  { 
    value: 'approved',
    label: 'Approved',
    icon: 'check_circle',
    iconLibrary: 'material',
    description: "Proposal was approved based on responses from the approvers",
  },
  { 
    value: 'auto-approved',
    label: 'Auto-Approved',
    icon: 'published_with_changes',
    iconLibrary: 'material',
    description: "Proposal was automatically approved by the approval flow logic",
  },
  { 
    value: 'declined',
    label: 'Declined',
    icon: 'cancel',
    iconLibrary: 'material',
    description: "Proposal was declined based on responses from the approvers",
  },
];
const versionApprovalStatusMap = Object.fromEntries(
  versionApprovalStatusOptions.map((o) => [o.value, o])
);

const versionApprovalFlowOptions = [
  { 
    value: 'guildMembers.invite',
    label: 'Guild Member Invitation',
    icon: 'forward_to_inbox',
    iconLibrary: 'material',
  },
  { 
    value: 'guildMembers.request',
    label: 'Guild Member Request',
    icon: 'person_raised_hand',
    iconLibrary: 'material',
  },
  { 
    value: 'guildMembers.deactivate',
    label: 'Guild Membership Deactivation',
    icon: 'do_not_disturb_on',
    iconLibrary: 'material',
  },
  { 
    value: 'guildMembers.point-onboard',
    icon: 'input_circle',
    label: 'Guild Point Onboard',
    iconLibrary: 'material',
  },
  { 
    value: 'guildMembers.point-offboard',
    label: 'Guild Point Offboard',
    icon: 'output_circle',
    iconLibrary: 'material',
  },
  { 
    value: 'projectMembers.invite',
    label: 'Project Member Invitation',
    icon: 'forward_to_inbox',
    iconLibrary: 'material',
  },
  { 
    value: 'projectMembers.request',
    label: 'Project Member Request',
    icon: 'person_raised_hand',
    iconLibrary: 'material',
  },
  { 
    value: 'projectMembers.deactivate',
    label: 'Project Membership Deactivation',
    icon: 'do_not_disturb_on',
    iconLibrary: 'material',
  },
  { 
    value: 'projectMembers.point-onboard',
    icon: 'input_circle',
    label: 'Project Point Onboard',
    iconLibrary: 'material',
  },
  { 
    value: 'projectMembers.point-offboard',
    label: 'Project Point Offboard',
    icon: 'output_circle',
    iconLibrary: 'material',
  },
  { 
    value: 'guildProjects.invite',
    label: 'Guild Project Invitation',
    icon: 'forward_to_inbox',
    iconLibrary: 'material',
  },
  { 
    value: 'guildProjects.request',
    label: 'Guild Project Request',
    icon: 'person_raised_hand',
    iconLibrary: 'material',
  },
  { 
    value: 'guildProjects.deactivate',
    label: 'Guild Project Deactivation',
    icon: 'do_not_disturb_on',
    iconLibrary: 'material',
  },
];
const versionApprovalFlowMap = Object.fromEntries(
  versionApprovalFlowOptions.map((o) => [o.value, o])
);

/*=== EXPORTS ===*/

export {
  versionSubjectCollectionOptions,
  versionSubjectCollectionMap,

  versionResponseStatusOptions,
  versionResponseStatusMap,

  versionStatusOptions,
  versionStatusMap,
               
  versionApprovalStatusOptions,
  versionApprovalStatusMap,

  versionApprovalFlowOptions,
  versionApprovalFlowMap,
};
